import http from "@seims/shared/src/services/HttpService";
import local from "../data/candidates";

var endpoint = `/candidate/`;

const headers = {};

const addDemographics = async (demographics) => {
  let response;
  const { address, id } = demographics;

  const data = {
    id: id,
    userId: demographics.userId,
    // "uuid": "00000000-0000-0000-0000-000000000000",
    dob: demographics.dob,
    disability: demographics.disability,
    idNumber: demographics.idNumber,
    alternativePersonFullName: demographics.alternativePersonFullName,
    alternativeCellNumber: demographics.alternativeCellNumber,
    race: demographics.race.key,
    gender: demographics.gender.key,
    title: demographics.title.key,
    preNYSActivity: demographics.preNYSActivity.key,
    preferredProvince: demographics.preferredProvince.key,
    genderOther: demographics.genderOther,
    email: demographics.email,
    name: demographics.name,
    surname: demographics.surname,
    cellNumber: demographics.cellNumber,
    lastModified: new Date().toISOString(),
    homeProvince: demographics.homeProvince.key,
    address: {
      id: address.id,
      province: address.province,
      cityOrTown: address.cityOrTown,
      street: address.street,
      postalCode: address.postalCode,
      country: "South Africa",
      x: 0,
      y: 0,
    },
  };

  if (demographics.id > 0) {
    response = await http.put(`${endpoint}demographics/${id}`, data, {
      headers: headers,
    });
  } else {
    response = await http.post(`${endpoint}save/demographics`, data, {
      headers: headers,
    });
  }
  return response;
};

const addQualifications = async (qualifications) => {
  let response;
  const { id } = qualifications;
  let data = {
    id: id,
    highestQualification: qualifications.highestQualification,
    subjects: qualifications.subjects,
    fieldOfStudy: qualifications.fieldOfStudy,
    institutionOfStudy: qualifications.institutionOfStudy,
    grade12CompletionYear: qualifications.grade12CompletionYear,
    userId: qualifications.userId,
    lastModified: new Date().toISOString(),
  };

  if (id > 0) {
    response = await http.put(`${endpoint}qualifications/${id}`, data, {
      headers: headers,
    });
  } else {
    response = await http.post(`${endpoint}save/qualifications`, data, {
      headers: headers,
    });
  }
  return response;
};

const addSuppDocuments = async (files) => {
  var formData = new FormData();
  const _files = files.filter((c) => c.hasFile === true);

  const _metadata = _files.map((item) => ({
    id: item.id,
    documentType: item.documentType,
    filename: item.fileName,
  }));

  _files.forEach((item) => {
    let metadataJson = JSON.stringify(_metadata);
    // let metadataBlob = new Blob([metadataJson], { type: "application/json" });

    formData.append("files", item.file);
    formData.append("metadata", metadataJson);

    // formData.append("metadata", metadataBlob, "metadata.json");
    // formData.append("metadata", metadataBlob, {
    //   contentType: "application/json",
    // });

    
  });

  const response = await http.post(
    `${endpoint}save/supporting/documents`,
    formData
  );
  return response;
};

const getFile = async (id, userId) => {
  const response = await http.get(
    `${endpoint}supporting/documents/${id}/${userId}`,
    { responseType: "arraybuffer" }
  );
  return response;
};

const getFileForHost = async (uuid) => {
  const response = await http.get(`${endpoint}host/view/documents/${uuid}`, {
    responseType: "arraybuffer",
  });
  return response;
};

const submitProfile = async (id, userId) => {
  const response = await http.post(`${endpoint}save`);
  return response;
};

const getCandidate = async () => {
  const response = await http.get(`${endpoint}view`);
  return response;
};

const updateLinkDetails = async (linkToken) => {
  const response = await http.get(`${endpoint}host/view/${linkToken}`);
  return response;
};

const withdraw = async (intake) => {
  const response = await http.post(`${endpoint}withdraw?intake=${intake}`);
  return response;
};

const getClosingDate = async (selectedYear) => {
  const endpoint = `candidate/intakes/current`;
  const response = await http.get(`${endpoint}`);
  return response;
};

const getUniqueIdNumber = async (idNumber) => {
  const endpoint = `candidate/idnumberexists`;
  const response = await http.post(`${endpoint}`, {idNumber: idNumber}, {
      headers: headers,
    });
  return response;
};

export default {
  getCandidate,
  getClosingDate,
  getFile,
  getUniqueIdNumber,
  addDemographics,
  addQualifications,
  addSuppDocuments,
  submitProfile,
  updateLinkDetails,
  getFileForHost,
  withdraw,
};
